import {combineEpics} from 'redux-observable';

const epic = combineEpics();

export default epic;
